import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ObjectivesService } from '../objectives.service';
import { GroupByMetric, ObjectiveAssignmentDataObj } from '../objective-landing/objective-landing.models';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
  selector: 'cv-objective-metrics-assigned',
  templateUrl: './objective-metrics-assigned.component.html',
  styleUrls: ['./objective-metrics-assigned.component.scss']
})
export class ObjectiveMetricsAssignedComponent implements OnInit {
    @Input() filtertext: string = ""; // Text sent from the outside search box used to filter the small metric cards
    @Output() filtertextChange: EventEmitter<string> = new EventEmitter<string>();

    filterSelectedText: string = ""; // Text from the internal search box used on the large data cards
    LocalizationMessages: Map<string, string>;
    visibleGroupLevels = {
        'all': false,
        'emp1': false,
        'emp2': false,
        'emp3': false,
        'emp4': false,
        'emp5': false,
        'rec1': false,
        'rec2': false,
        'rec3': false,
        'rec4': false,
        'rec5': false
    };
    showMetricGroup = {
        'all': true,
        'emp1': true,
        'emp2': true,
        'emp3': true,
        'emp4': true,
        'emp5': true,
        'rec1': true,
        'rec2': true,
        'rec3': true,
        'rec4': true,
        'rec5': true
    };
    confirmationDialogOpen = false;
    confirmObj = null;

    constructor(
        public objectiveService: ObjectivesService,
        private cvLocalizationService: CVLocalizationService,
    ) {}

    ngOnInit(): void {
        this.cvLocalizationService.GetSection("Objectives").then(res => {
            this.LocalizationMessages = res;
        });
    }

    /*filterMetrics(obj: GroupByMetric) {
        let match_name_filter = false;

        //Null? seems bad...
        if (obj == null) return false;

        //Name match
        if (!(this.filtertext == "")) {
            if (obj.name.toLowerCase().indexOf(this.filtertext.toLowerCase()) > -1)
                match_name_filter = true;
        }
        else
            match_name_filter = true;

        return match_name_filter;
    };

    filterSelectedMetrics(item: ObjectiveAssignmentDataObj) {
        let match_name_filter = false;

        //Null? seems bad...
        if (item == null) return false;

        //Name match
        if (!(this.filterSelectedText == "")) {
            for (let i = 0; i < item.assignments.emp.length; i++) {
                if (item.assignments.emp[i].GroupName.toLowerCase().indexOf(this.filterSelectedText.toLowerCase()) > -1) {
                    match_name_filter = true;
                    break;
                }
            }

            if (!match_name_filter) {
                for (let i = 0; i < item.assignments.rec.length; i++) {
                    if (item.assignments.rec[i].GroupName.toLowerCase().indexOf(this.filterSelectedText.toLowerCase()) > -1) {
                        match_name_filter = true;
                        break;
                    }
                }
            }

            if (!match_name_filter) {
                for (let i = 0; i < item.assignments.attr.length; i++) {
                    if (item.assignments.attr[i].AttributeValueName.toLowerCase().indexOf(this.filterSelectedText.toLowerCase()) > -1) {
                        match_name_filter = true;
                        break;
                    }
                }
            }
        }
        else
            match_name_filter = true;

        return match_name_filter;
    }*/

    clearSelectedSearch() {
        this.filterSelectedText = "";
    }

    applyFilter() { }

    scrollToTop() {
        //Force a scroll to the top of the page since scrolling on configure pages causes odd scrolling
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    selectMetric(obj: GroupByMetric) {
        this.objectiveService.selectedMetric = angular.copy(obj);
        this.setVisibleLevels();
        this.objectiveService.showLandingHeader = false;
        this.objectiveService.showMetricCardView = false;
        this.objectiveService.showMetricSelectView = true;

        this.scrollToTop();
    }

    backClick() {
        this.objectiveService.showLandingHeader = true;
        this.objectiveService.showMetricCardView = true;
        this.objectiveService.showMetricSelectView = false;

        this.objectiveService.selectedMetric = null;
        this.showMetricGroup = {
            'all': true,
            'emp1': true,
            'emp2': true,
            'emp3': true,
            'emp4': true,
            'emp5': true,
            'rec1': true,
            'rec2': true,
            'rec3': true,
            'rec4': true,
            'rec5': true
        };
    }

    setVisibleLevels() {
        this.visibleGroupLevels.all = false;
        this.visibleGroupLevels.emp1 = false;
        this.visibleGroupLevels.emp2 = false;
        this.visibleGroupLevels.emp3 = false;
        this.visibleGroupLevels.emp4 = false;
        this.visibleGroupLevels.emp5 = false;
        this.visibleGroupLevels.rec1 = false;
        this.visibleGroupLevels.rec2 = false;
        this.visibleGroupLevels.rec3 = false;
        this.visibleGroupLevels.rec4 = false;
        this.visibleGroupLevels.rec5 = false;

        // For each objective, check if it matches the selected metric and then show any buckets with at least 1 core card assigned at that type and level
        for (let loadedObjective of this.objectiveService.loadedObjectives) {
            if (loadedObjective.MetricID == this.objectiveService.selectedMetric.metricID) {
                if (loadedObjective.combinedObj.AssignedLevel == 6)
                    this.visibleGroupLevels.all = true;
                else if (loadedObjective.combinedObj.GroupingID == 0)
                    this.visibleGroupLevels[loadedObjective.combinedObj.AssignedType + loadedObjective.combinedObj.AssignedLevel] = true;
            }
        }
    }

    editObjectiveClick(obj: ObjectiveAssignmentDataObj) {
        this.scrollToTop();

        this.objectiveService.editObjective(obj, true);
    }

    isLowestCard(obj: ObjectiveAssignmentDataObj) {
        let lowest = 6;

        for (let loadedObjective of this.objectiveService.loadedObjectives) {
            if ((loadedObjective.combinedObj.ObjectiveID == obj.combinedObj.ObjectiveID || loadedObjective.combinedObj.GroupingID == obj.combinedObj.ObjectiveID) && loadedObjective.combinedObj.AssignedLevel < lowest)
                    lowest = loadedObjective.combinedObj.AssignedLevel;
        }

        return lowest;
    }

    removeCard(evt, obj) {
        evt.stopPropagation();

        this.confirmationDialogOpen = true;
        this.confirmObj = obj;
    }

    removeCardConfirm() {
        let stringToRemove = "";
        let intList = [];
        if (this.confirmObj.combinedObj.GroupingID == 0) { // Core card so remove all the sub cards too
            for (let loadedObjective of this.objectiveService.loadedObjectives) {
                if (this.confirmObj.combinedObj.ObjectiveID == loadedObjective.combinedObj.ObjectiveID || this.confirmObj.combinedObj.ObjectiveID == loadedObjective.combinedObj.GroupingID) {
                    if (stringToRemove == "") {
                        stringToRemove += loadedObjective.combinedObj.ObjectiveID;
                        intList.push(loadedObjective.combinedObj.ObjectiveID);
                    }
                    else {
                        stringToRemove += "," + loadedObjective.combinedObj.ObjectiveID;
                        intList.push(loadedObjective.combinedObj.ObjectiveID);
                    }
                }
            }
        }
        else { // Remove only the sub card selected
            stringToRemove += this.confirmObj.combinedObj.ObjectiveID;
            intList.push(this.confirmObj.combinedObj.ObjectiveID);
        }

        this.objectiveService.removeObjectives(stringToRemove);

        for (let i = 0; i < this.objectiveService.loadedObjectives.length; i++) {
            for (let int of intList) {
                if (int == this.objectiveService.loadedObjectives[i].combinedObj.ObjectiveID) {
                    if (this.objectiveService.loadedObjectives[i].combinedObj.GroupingID == 0)
                        this.objectiveService.selectedMetric.count--;

                    this.objectiveService.loadedObjectives.splice(i, 1);
                    i--;
                }
            }
        }

        this.confirmationDialogOpen = false;

        this.objectiveService.setGroupObjByMetric();
        this.setVisibleLevels();
    }

    clickNewMetricsObjective() {
        this.scrollToTop();

        this.objectiveService.showAddEditObjective = true;

        this.objectiveService.addEdit.originalObjectives = [];
        this.objectiveService.addEdit.editedObjectives = [];
        this.objectiveService.addNewObjective(0, 0);
        this.objectiveService.addEdit.selectedObjective = 0;
        this.objectiveService.addEdit.assignedGroups = [];
        this.objectiveService.addEdit.originalAssignedGroups = [];
        this.objectiveService.addEdit.MetricID = 0;
        this.objectiveService.addEdit.MetricName = "";
        this.objectiveService.addEdit.MetricValueType = null;
        this.objectiveService.addEdit.MetricObjectiveType = null;
        this.objectiveService.addEdit.MetricValueTimeType = null;
        this.objectiveService.addEdit.MetricDirection = null;
        this.objectiveService.addEdit.MetricIsRealtime = null;
        this.objectiveService.addEdit.selectedRange = null;

        this.objectiveService.showLandingHeader = false;

        if (this.objectiveService.showLandingMetricTab) {
            this.objectiveService.showMetricCardView = true;
            this.objectiveService.showMetricSelectView = false;
        }

        this.objectiveService.addEdit.assignedGroups.coreAssignAtLevel = null;
        this.objectiveService.addEdit.assignedGroups.coreAssignAtType = null;
        this.objectiveService.addEdit.assignedGroups.assignOptions = {};
        if (this.objectiveService.selectedMetric.objectiveType == 1) {
            this.objectiveService.addEdit.assignedGroups.coreAssignAtLevel = 6;
            this.objectiveService.addEdit.assignedGroups.coreAssignAtType = "emp";

            this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtLevel = 6;
            this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtType = "emp";
            this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtOption = "normal";
        }
        else if (this.objectiveService.selectedMetric.objectiveType == 0) {
            this.objectiveService.addEdit.assignedGroups.coreAssignAtLevel = 1;
            this.objectiveService.addEdit.assignedGroups.coreAssignAtType = "emp";

            this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtLevel = 1;
            this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtType = "emp";
            this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtOption = "parent";
        }

        this.objectiveService.addEdit.selectedObjective = 0;

        this.objectiveService.addEdit.MetricID = this.objectiveService.selectedMetric.metricID;
        this.objectiveService.addEdit.MetricName = this.objectiveService.selectedMetric.name;
        this.objectiveService.addEdit.MetricObjectiveType = this.objectiveService.selectedMetric.objectiveType;
        this.objectiveService.addEdit.MetricValueType = this.objectiveService.selectedMetric.numericType;
        this.objectiveService.addEdit.MetricValueTimeType = this.objectiveService.selectedMetric.timeType;
        this.objectiveService.addEdit.MetricDirection = this.objectiveService.selectedMetric.direction;
        this.objectiveService.addEdit.MetricIsRealtime = this.objectiveService.selectedMetric.isRealTime;
    }

    labelFilter(labels) {
        return labels.filter(l => this.visibleGroupLevels[(l.BaseGroupType == 0 ? 'emp' : 'rec') + l.GroupLevel]);
    }

    objFilter(objectives) {
        return objectives.filter(o => o.MetricID == this.objectiveService.selectedMetric.metricID && o.assignments.emp.length == 0 && o.assignments.rec.length == 0);
    }

    objLabelFilter(objectives, label) {
        return objectives.filter(o => o.MetricID == this.objectiveService.selectedMetric.metricID && o.combinedObj.GroupingID == 0 && o.combinedObj.AssignedType == (label.BaseGroupType == 0 ? 'emp' : 'rec')
            && o.combinedObj.AssignedLevel == label.GroupLevel
            && (!this.filterSelectedText || o.assignments.emp.filter(p => p.GroupName.toLowerCase().indexOf(this.filterSelectedText.toLowerCase()) > -1).length > 0
                || o.assignments.rec.filter(p => p.GroupName.toLowerCase().indexOf(this.filterSelectedText.toLowerCase()) > -1).length > 0
                || o.assignments.attr.filter(p => p.GroupName.toLowerCase().indexOf(this.filterSelectedText.toLowerCase()) > -1).length > 0));
    }

    subObjFilter(subObjectives, objective) {
        return subObjectives.filter(s => s.combinedObj.GroupingID == objective.combinedObj.ObjectiveID);
    }

    paletteFilter(palettes, objective) {
        return palettes.filter(p => p.ObjectivePaletteID == objective.combinedObj.ObjectivePaletteID);
    }
}
